export const wallId = 51777;
export const siteRoot = ""; // "/ui23jksdio6";
